export enum UserAccountType {
  Guest = 0,
  Facebook = 1,
  Apple = 2,
  Google = 3
}
